import React, { ReactElement } from 'react';
import { IInvalidInvitationPageProps } from '../../types';
import { DevLoginFooter } from './common/DevAuthFooter';
import { DevAuthHeader } from './common/DevAuthHeader';

export function InvalidInvitationPage({
    error_message,
}: IInvalidInvitationPageProps): ReactElement {
    return (
        <div className='narrow'>
            <DevAuthHeader />

            <div className='block submitted_loading'>
                <div className='card login_card submitted_hide'>
                    <div>
                        <p className='invalid'>
                            {error_message || 'Unfortunately this invitation is no longer valid.'}
                        </p>
                    </div>
                </div>
            </div>

            <DevLoginFooter />
        </div>
    );
}
